import React, { useContext } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { Context } from '../../../Context'
import Image from '../../../content/images/LogoBlancoSise.png';
import NaseImage from '../../../content/images/LogoSmall01.png'
import useStyles from './NavBarStyles';
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from '@material-ui/core/Divider';
import { addAuditLogin } from '../../../services/auditService'

export const NavBar = () => {
  const classes = useStyles();
  const { isAuth, removeAuth } = useContext(Context);
  function getDataToAuditLogin (documentType, documentNumber) {
      return ({
          EventTypeLogin: 'LOGOUT',
          DocumentTypeId : parseInt(documentType), 
          DocumentNumber : documentNumber
      })
  }

  async function Logout(){
    const user = JSON.parse(localStorage.getItem('user'))
    removeAuth(false);
    await addAuditLogin(getDataToAuditLogin(user.DocumentType, user.DocumentNumber))
  }

  return (
    <>
      <CssBaseline />
      <AppBar position="static">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <img src={Image} className={classes.imgSise} />
            <Divider orientation="vertical" flexItem className={classes.divider} />
            <img src={NaseImage} className={classes.imgNaseSeguros} />
          </IconButton>
          <Typography variant="subtitle1" className={classes.title}>
            PORTAL DE PAGOS
          </Typography>
          {
            isAuth ?
              <IconButton onClick={Logout} aria-label="exit" color="secondary" align="right">
                <Typography>SALIR</Typography>
                <ExitToAppIcon />
              </IconButton>
            :
              null
          }
        </Toolbar>
      </AppBar>
    </>
  );
}